module.exports = __webpack_public_path__ + "w4zpd3n.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ranks/27.jpg
// module id = 555
// module chunks = 1